<template>
  <b-col cols="10" offset-md="2">
    <b-tabs content-class="mt-3" v-if="loaded">
      
      <!-- Solo mostrar este tab si es superusuario -->
      <b-tab v-if="isSuperuser" title="Chat Mesa de Ayuda Técnica" active>
        <b-card title="Mesa de Ayuda TÉCNICA" class="w-100 mb-5">
          <div class="iframe-wrapper">
            <iframe
              src="https://www.chatbase.co/chatbot-iframe/K0cQWRqYiVIEmTBOCrX8z"
              class="chatbase-iframe"
              frameborder="0"
            ></iframe>
          </div>
        </b-card>
      </b-tab>

      <!-- Este tab siempre se muestra -->
      <b-tab :active="!isSuperuser" title="Chat Mesa de Ayuda Funcional">
        <b-card title="Mesa de Ayuda FUNCIONAL" class="w-100 mb-5">
          <div class="iframe-wrapper">
            <iframe
              src="https://www.chatbase.co/chatbot-iframe/Mq1y2KnVsgZbTPZzNxbKO"
              class="chatbase-iframe"
              frameborder="0"
            ></iframe>
          </div>
        </b-card>
      </b-tab>

    </b-tabs>
  </b-col>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ChatTabs',
  data() {
    return {
      isSuperuser: false,
      loaded: false
    }
  },
  mounted() {
    const token = localStorage.getItem("usertoken");

    if (token) {
      axios.get("https://it-backend.synagro.com.ar/api/v1.0/user-role/", {
        headers: {
          Authorization: `Token ${token}`
        }
      })
      .then(response => {
        this.isSuperuser = response.data.is_superuser;
        console.log(this.isSuperuser)
      })
      .catch(error => {
        console.error("Error consultando rol del usuario:", error);
        this.isSuperuser = false;
      })
      .finally(() => {
        this.loaded = true;
      });
    } else {
      this.loaded = true;
    }
  }
}
</script>

<style scoped>
.iframe-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.chatbase-iframe {
  width: 80%;
  min-height: 700px;
  border: 2px solid #000;
  border-radius: 12px;
}
</style>
